"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidEmailAddress = void 0;
const CademyError_1 = __importDefault(require("../../Domain/CademyError"));
class InvalidEmailAddress extends CademyError_1.default {
    constructor(detail, status, instance) {
        const type = `generic/invalid-email-address`;
        super(type, 'Invalid Email Address', detail, status, instance);
    }
}
exports.InvalidEmailAddress = InvalidEmailAddress;
exports.default = InvalidEmailAddress;
